// This file provides functions to manage cookie consent for the widget
import { updateCookieConsent } from './analytics';

/**
 * Updates the cookie consent settings for the widget
 * @param consent - Object containing consent settings
 * @example
 * updateWidgetCookieConsent({
 *   analytics: true,   // Allow analytics cookies (GA, Clarity)
 *   marketing: false,  // Disallow marketing cookies
 *   functional: true,  // Allow functional cookies
 *   necessary: true    // Allow necessary cookies (always true)
 * });
 */
export function updateWidgetCookieConsent(consent: {
  analytics?: boolean;
  marketing?: boolean;
  functional?: boolean;
  necessary?: boolean;
}): void {
  updateCookieConsent(consent);
}
